var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
import { graphql } from "react-apollo";
export var fetchAllWithdrawalsQuery = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query FetchAllWithdrawalsQuery {\n    fetchAllWithdrawals {\n      id\n      address\n      created\n      isInBatch\n      withdrawalTime\n      fiatOrderQuantity\n      paymentQuantity\n      smallOrderSurcharge\n      filledPrice\n      satsToWithdraw\n      payRef\n      status\n      tradingPair\n      is_ln_withdrawal\n      ln_description\n    }\n  }\n"], ["\n  query FetchAllWithdrawalsQuery {\n    fetchAllWithdrawals {\n      id\n      address\n      created\n      isInBatch\n      withdrawalTime\n      fiatOrderQuantity\n      paymentQuantity\n      smallOrderSurcharge\n      filledPrice\n      satsToWithdraw\n      payRef\n      status\n      tradingPair\n      is_ln_withdrawal\n      ln_description\n    }\n  }\n"])));
// export HOC
export var withFetchAllWithdrawals = graphql(fetchAllWithdrawalsQuery, {
    props: function (_a) {
        var data = _a.data;
        var withdrawals = [];
        if (data && !data.loading && data.fetchAllWithdrawals) {
            withdrawals = data.fetchAllWithdrawals;
        }
        return {
            withdrawals: withdrawals,
            // if data exists return data otherwise return false
            loading: data ? data.loading : false,
        };
    },
});
var templateObject_1;
//# sourceMappingURL=index.js.map